import { Box, styled } from "@mui/material";

export const TextContainer = styled(Box)(() => ({
  marginTop: "16px",
}));
